import getRandomInt from "./getRandomInt";
export default function getRandomIntArray(min, max, arraySize = 2, nonZero = false) {
    let intArray = [];
    for (let i = 0; i < arraySize; i++) {
        let a = getRandomInt(min, max, nonZero);
        while (intArray.includes(a)) {
            a = getRandomInt(min, max, nonZero);
        }
        intArray.push(a);
    }
    return intArray;
}
